import { TextureLoader } from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { Canvas3d } from "./Canvas3d.js";

export interface Scene3dOptions {
    assetsUrl: string;
    modelUrl: string;
    canvas: Canvas3d;
}

export class Scene3d {

    private _canvas: Canvas3d;
    private _modelUrl: string;

    constructor(options: Scene3dOptions) {

        let canvas = options.canvas;
        let assetsUrl = options.assetsUrl;

        this._modelUrl = options.modelUrl;
        this._canvas = options.canvas;

        var tl = new TextureLoader();
        canvas.scene.background = tl.load(assetsUrl + '/background.jpg');
    }

    public async load(onProgress:(loaded:number, total:number) => void) {
        const loader = new GLTFLoader();
        const gltf: any = await loader.loadAsync(
            // resource URL
            this._modelUrl,
            // called while loading is progressing
            (xhr: any) => {
                // console.log((xhr.loaded / xhr.total * 100) + '% loaded');
                onProgress(xhr.loaded, xhr.total);
            }
        );

        // ,
        //     // called when loading has errors
        //     (error: any) => {
        //         console.log('An error happened', error);
        //         throw new Error("Error loading model");

        //     }

        // gltf.scene.traverse(function (node: any) {

        //     if (node.isMesh || node.isLight) {
        //         node.castShadow = true;

        //         if (node.name == "Ice_Base_02"
        //             || node.name == "Ocean_Top"
        //             || node.name == "Pond_Top_New") {
        //             node.castShadow = false;
        //             node.receiveShadow = true;
        //         }
        //     }
        // });

        gltf.scene.name = "global-scene";

        this._canvas.scene.add(gltf.scene);

        gltf.animations; // Array<THREE.AnimationClip>
        gltf.scene; // THREE.Group
        gltf.scenes; // Array<THREE.Group>
        gltf.cameras; // Array<THREE.Camera>
        gltf.asset; // Object
    }
}